import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Reorder.svg",
  "use": "Reorder.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Reorder.svg\">\n  <path d=\"M52.01 44.02h-40a2 2 0 0 1 0-4h40a2 2 0 1 1 0 4zm0-20h-40a2 2 0 0 1 0-4h40a2 2 0 1 1 0 4zm0 10h-40a2 2 0 0 1 0-4h40a2 2 0 1 1 0 4z\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol